import React, { FormEvent, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
// import SelectInput from "../../components/SelectInput";
import {
  ModalContainer,
  ModalContent,
  ModalRoot,
} from 'src/components/ui/modal'
import * as yup from 'yup'
import { StepHeader } from '../../components/stepHeader'
import TextInput from '../../components/TextInput'

import { showAlertError } from 'src/components/alertError'
import { Loading } from 'src/components/loading'
import { api } from 'src/services/api'
import { isAxiosError } from 'src/utils/isAxiosError'
import { useClient } from '../../hooks/client'
import { service } from '../../services/ajio'
import type { DevicesProps } from '../authorizedDevices/AutorizedListDevices'
import './style.css'
import {
  ButtonWrapper,
  Container,
  Content,
  ContentWrapper,
  Form,
  FormTitle,
  FormWrapper,
  WrapperHeader,
} from './styles'

type FormData = {
  document: string
  name: string
  agency: string
  account: string
  digit: string
}

const schema = yup
  .object({
    name: yup.string().required('Nome é obrigatório'),
    document: yup.string().required('Documento é obrigatório'),
    agency: yup.string().required('Agência é obrigatório'),
    account: yup.string().required('Conta é obrigatório'),
    digit: yup.string().required('Dígito é obrigatório.'),
  })
  .required()

export const TransferListWallet: React.FC = () => {
  const { client } = useClient()

  const [document, setDocument] = useState('')
  const [loading, setLoading] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const token = localStorage.getItem('@stricv2:token')
  const [data, setData] = useState<DevicesProps[]>([])

  // const handlePersonalAccount = () => {
  //   setButtonSelected("personal");
  // };
  // const handleBusinnessAccount = () => {
  //   setButtonSelected("businness");
  // };

  // const [selectedAccountType, setSelectedAccountType] =
  //   useState("Tipo de conta");

  // const handleAccountTypeSelect = (option: string) => {
  //   setSelectedAccountType(option);
  // };

  // const [selectedBank, setSelectedBank] = useState("Banco");
  // const handleBankSelect = (option: string) => {
  //   setSelectedBank(option);
  // };

  const fetchDevices = async () => {
    try {
      // Substituindo a chamada à API por dados fictícios
      const { data: responseData } = await api.get('/devices', {
        headers: { Authorization: `Bearer ${token}` },
      })
      // Transformar o objeto em um array, caso seja um único item
      const deviceArray = Array.isArray(responseData)
        ? responseData
        : [responseData]
      setData(deviceArray)
    } catch (error) {
      console.error('Erro ao buscar os dados:', error)
    }
  }

  useEffect(() => {
    fetchDevices()
  }, [])

  const handleFormSubmit = async (e: FormEvent) => {
    e.preventDefault()
    setLoading(true)

    const documentFormatted = document.replace(/[/,.,-\s]/g, '')

    try {
      const {
        data: { user },
      } = await service.get(`/account/info?document=${documentFormatted}`)

      console.log(user)
      setLoading(false)
      navigate('/transfer-wallet/wallet-confirm', {
        state: {
          role: user.role || 'WALLET',
          name: user.name,
          document: user.document,
          agency: '1001',
          account: user.number_identifier,
          virtualAccountId: user.virtual_account_id,
          receiverId: user.id,
          id: user.account.refId,
          bank: {
            id: 0,
            name: client.name,
            hidden: client.name,
          },
        },
      })
      return
    } catch (error) {
      if (isAxiosError(error) && error.response) {
        if (error.response.status === 401) {
          setLoading(false)
          return setIsModalOpen(true)
        }
        setLoading(false)
        const errorMessage = (error.response.data as { message: string })
          .message
        showAlertError(errorMessage)
      } else {
        showAlertError('Ocorreu um erro inesperado.')
        setLoading(false)
      }
    }
  }

  const navigate = useNavigate()

  const handleNextScreen = () => {
    navigate('/transfer-wallet/wallet-confirm')
  }

  const handleGoBack = () => {
    navigate('/pix/pix-and-transfers')
  }

  return (
    <Container className="w-full">
      <Content className="w-full h-full flex items-center justify-center">
        <ContentWrapper className="w-full h-full">
          <WrapperHeader className="w-full max-w-[30%]">
            <StepHeader
              handleGoBackFunction={handleGoBack}
              title="Iniciando Transação entre Contas"
            />
          </WrapperHeader>
          <Form
            className="w-full h-full max-h-[50%] max-w-[30%]"
            onSubmit={handleFormSubmit}
          >
            {/* <SelectButtonWrapper>
              <FormSelectButton
                isSelected={buttonSelected === "personal"}
                onClick={handlePersonalAccount}
                buttonName={"Transferir para Pessoa Física"}
              />
              <FormSelectButton
                isSelected={buttonSelected === "businness"}
                onClick={handleBusinnessAccount}
                buttonName={"Transferir para Pessoa Jurídica"}
              />
            </SelectButtonWrapper> */}

            <FormTitle className="p-texte">Informe o CPF/CNPJ</FormTitle>
            <FormWrapper>
              <div className="mb-5">
                <TextInput
                  className="p-texte"
                  mask="CPF_CNPJ"
                  placeholder={'CPF/CNPJ'}
                  onChange={(input: any) => setDocument(input.target.value)}
                  value={document}
                />
              </div>

              {/* <SelectInput
                optionSelected={selectedAccountType}
                handleFunction={handleAccountTypeSelect}
                options={["Conta Corrente", "Conta Poupança"]}
              /> */}
            </FormWrapper>
            <ButtonWrapper className="h-full max-h-[30%]">
              <button
                type="submit"
                className="bg-[#FE9E18] flex items-center justify-center text-white w-full h-[40%] rounded-md p-texte"
              >
                {loading ? <Loading isLoading={loading} /> : 'Continuar'}
              </button>
            </ButtonWrapper>
          </Form>
        </ContentWrapper>
      </Content>
      <ModalRoot open={isModalOpen} setIsOpen={setIsModalOpen}>
        <ModalContainer>
          <ModalContent>
            {data.length === 3 ? (
              <div className="flex flex-col gap-4 items-center p-4">
                <h1 className="text-[1.875rem] font-bold">
                  Já existe 3 dispositivos cadastrados
                </h1>
                <div className="w-full flex gap-3 justify-center">
                  <button
                    type="button"
                    onClick={() => setIsModalOpen(false)}
                    className="bg-[#004A8A] text-white py-2 px-4 rounded-md"
                  >
                    Voltar
                  </button>
                </div>
              </div>
            ) : (
              <div className="flex flex-col gap-4 items-center p-4">
                <h1 className="text-[1.875rem] font-bold">
                  Dispositivo não cadastrado
                </h1>
                <div className="w-full flex gap-3 justify-center">
                  <button
                    type="button"
                    onClick={() => navigate('/wallet/security-devices/enable')}
                    className="bg-[#004A8A] text-white py-2 px-4 rounded-md"
                  >
                    Cadastrar
                  </button>
                </div>
              </div>
            )}
          </ModalContent>
        </ModalContainer>
      </ModalRoot>
    </Container>
  )
}
